import { useAppSelector, useAppDispatch } from '../../../../../stores/hook'
import { useEffect, useMemo, useRef, useState } from 'react'
import { setSubscribeModalStatus } from '../../GetStartedSlice'

import styles from './SubscribeModal.module.scss'
import translations from '../../../../../text/get-started-translations.json';
import language from '../../../../../utils/LanguageSettings';
import { IPriceOption } from '../../../types';
import { BlocksContent } from "@strapi/blocks-react-renderer";
import { appendUtmParams } from '../../../../../utils/Url';
import { OTT, STB } from '../../../constants';
import ReactMarkdown from 'react-markdown';
import gfm from 'remark-gfm';
import rehypeRaw from "rehype-raw";
import React from 'react';
import { roundUpPrice } from '../../../../../utils/PriceUtil';
import closeImage from '../../../../../images/icon/icon-close.svg';
import { custTypeMapping } from '../../../../functions/filterCustomerTypeDisplay';
import { useLocation } from 'react-router-dom';
import { useAuth } from '../../../../../contexts/AuthProvider';
import { buildLoginUrl } from '../../../../../utils/authHelper';

const SubscribeModal: React.FC<{ locale?: string }> = ({ locale }) => {
  const { userData } = useAuth();
  const authData = (userData || {}) as any;
  
  // const pageTranslations = translations[language]; // Select the correct translations
  const isShow = useAppSelector((state) => state.getStarted.isShowSubscribeModal)
  const [isShowAlter, setIsShowAlter] = useState<boolean>(false);
  const packInfo = useAppSelector((state) => state.getStarted.packInfo)
  const isTvBoxPage = useAppSelector((state) => state.getStarted.isTvBoxPage)
  const isBoxPlan = useAppSelector((state) => state.getStarted.isBoxPlan)
  const dispatch = useAppDispatch();
  const listenerPlanRef = useRef(null);
  let custType = authData.cust_type;
  const loginUrl = buildLoginUrl(language as 'en' | 'zh', window.location.pathname);
   const location = useLocation();
   const isArticlePage = location.pathname.includes('/blog/');
   const langKey = (isArticlePage && locale) || language;
   const pageTranslations = translations[langKey as keyof typeof translations];

  useEffect(() => {
    if (isShow) {
      setIsShowAlter(true);
      document.getElementsByTagName("body")[0].classList.add("modal-open");
      document.getElementById("plan-modal-wrapper")?.classList.add("show");
    } else {
      document.getElementsByTagName("body")[0].classList.remove("modal-open");
      document.getElementById("plan-modal-wrapper")?.classList.remove("show");
    }
  }, [isShow])

  const filteredPriceOptions = useMemo(() => {
    return packInfo.PriceOptions
  }, [packInfo.PriceOptions, isTvBoxPage])

  const onClickBtn = (e: React.MouseEvent<HTMLDivElement>, priceOption: IPriceOption) => {
    const campaignCode = priceOption.Campaign;
    if (campaignCode) {
        if (isTvBoxPage) {
            window.location.href = '/subscriber-enquiry';
        } else {
            const paramName = priceOption.EPC ? 'epc' : 'campaign';
            let url = 'https://ssp.nowtv.now.com/choose-plan?' + paramName + '=' + campaignCode + '&lang=' + language;
            if (priceOption.Gift) {
                url += '&isGift=Y';
            }
            window.location.href = appendUtmParams(url);
        }
    } 
  }

  const renderSubscribeItems = () => {
    return (<div className={styles['plans-item-wrapper']}>
      {
        filteredPriceOptions.map((priceOption: IPriceOption, index: number) => (
          (
            <div key={priceOption.id} className={`${styles['item']} ${styles['plan-12-Month']}`}>
              <h4>
                {priceOption.PriceTitle}
                <p>{priceOption.PriceSubtitle}</p>
                </h4>
                <div className={`${styles.details}`}>
                  <div className={styles.offer}>
                      {
                        priceOption.Type === 'Yearly' && (
                          <div className={styles.price}>
                            { isTvBoxPage ?
                              <><b>$ {roundUpPrice(priceOption.Price / 12).toLocaleString('zh-HK')}</b> / {pageTranslations.mth}
                                <p>{pageTranslations["12MthsCommitment2"]}</p></> :
                              <><b>$ {priceOption.Price.toLocaleString('zh-HK')}</b> / {pageTranslations['12mth']}
                                <p>{pageTranslations.Avg} $ {roundUpPrice(priceOption.Price / 12).toLocaleString('zh-Hk')} / {pageTranslations.mth}</p></>
                            }
                            {priceOption.Remark && typeof priceOption.Remark === 'string' && (
                              <div>
                                <ReactMarkdown remarkPlugins={[gfm]} rehypePlugins={[rehypeRaw]} components={{p: React.Fragment,}}>{priceOption.Remark}</ReactMarkdown>
                              </div>
                            )}
                          </div>
                        )
                      }
                      {
                        priceOption.Type === 'Monthly' && (
                          <div className={styles.price}>
                            <b>$ {priceOption.Price.toLocaleString('zh-HK')}</b> / { pageTranslations.Month}
                            { !isTvBoxPage ?<p>{pageTranslations.Cancel}</p> : <></>}
                            {priceOption.Remark && typeof priceOption.Remark === 'string' && (
                              <div>
                                <ReactMarkdown remarkPlugins={[gfm]} rehypePlugins={[rehypeRaw]} components={{p: React.Fragment,}}>{priceOption.Remark}</ReactMarkdown>
                              </div>
                            )}
                          </div>
                        )
                      }
                      {
                        priceOption.Type === 'Daily' && (
                          <div className={styles.price}>
                            <b>$ {priceOption.Price.toLocaleString('zh-HK')}</b> / { pageTranslations['day']}
                            {priceOption.Remark && typeof priceOption.Remark === 'string' && (
                              <div>
                                <ReactMarkdown remarkPlugins={[gfm]} rehypePlugins={[rehypeRaw]} components={{p: React.Fragment,}}>{priceOption.Remark}</ReactMarkdown>
                              </div>
                            )}
                          </div>
                        )
                      }
                      {
                        priceOption.Type === 'Event' && (
                          <div className={styles.price}>
                            <b>$ {priceOption.Price.toLocaleString('zh-HK')}</b> / { pageTranslations['EventPass']}
                            {priceOption.Remark && typeof priceOption.Remark === 'string' && (
                              <div>
                                <ReactMarkdown remarkPlugins={[gfm]} rehypePlugins={[rehypeRaw]} components={{p: React.Fragment,}}>{priceOption.Remark}</ReactMarkdown>
                              </div>
                            )}
                          </div>
                        )
                      }
                  </div>
                  { !isBoxPlan ? 
                  <div onClick={(e: React.MouseEvent<HTMLDivElement>) => {
                            onClickBtn(e, priceOption);
                        }}
                        className={styles['button-control']}>
                    <span className={'btn primary'}>{priceOption.Gift ? pageTranslations.GiftNow : pageTranslations.Select}</span>
                </div> : custTypeMapping[custType] == "User Type 1 (Not Logged In)" ? 
                <div onClick={() => {
                            window.location.href = loginUrl;
                        }}
                        className={styles['button-control']}>
                    <span className={'btn primary'}>{priceOption.Gift ? pageTranslations.GiftNow : pageTranslations.Select}</span>
                </div> : <></>}
              </div>
            </div>
          )
        ))
      }
      <div className={styles["remarks"]}>
          {packInfo && packInfo.optionsContext && typeof packInfo.optionsContext === 'string' && (
            <div>
              <ReactMarkdown remarkPlugins={[gfm]} rehypePlugins={[rehypeRaw]}>{packInfo.optionsContext}</ReactMarkdown>
            </div>
          )}
      </div>
    </div>)
  }

  useEffect(() => {
      const handlePackLiener = (event: any) => {
        const targetDiv = document.getElementById('plan-alter-wrapper');
        if (targetDiv && !targetDiv.contains(event.target)) {
          onCloseClick();
        }
      };
  
      listenerPlanRef.current = handlePackLiener;
  
      if (isShowAlter) {
        document.addEventListener('click', handlePackLiener);
      } else {
        document.removeEventListener('click', handlePackLiener);
      }
  
      return () => {
        document.removeEventListener('click', listenerPlanRef.current);
      };
    }, [isShowAlter]);

  const onCloseClick = () => {
    setIsShowAlter(false);
    dispatch(setSubscribeModalStatus(false))
  }
  return (
    <div id='plan-modal-wrapper' className={`${styles['modal-wrapper']} modal-wrapper`} style={{display: isShow ? undefined : 'none'}}>
      <div className={styles['modal-dialog']}>
        <div className={`${styles['modal-content-wrapper']} ${styles['sm']}`}>
          <div className={styles['close-wrap']}>
            <div className={styles['close-btn']}>
              <button onClick={onCloseClick} className={`${styles['close-modal']} ${styles['close-Plans']}`}>
                {pageTranslations.Close}&nbsp;
                <img src={closeImage} alt="Close icon"></img>
                </button>
            </div>
          </div>
          <div id="plan-alter-wrapper" className={`${styles['alert-wrapper']} ${styles['commitment-free-wrapper']}`}>
            <h3>{packInfo.name}</h3>
            {renderSubscribeItems()}
          </div>
        </div>
      </div>
    </div>
)}

export default SubscribeModal